import React from 'react'
import styled from 'styled-components'

export const BodyWrapper = styled.div`
  position: relative;
  max-width: 962px;
  width: 100%;
  background: linear-gradient(to bottom, #000000, #231f20);
  box-shadow: 0 10px 9.4px -2px rgba(0, 0, 0, 0.25);
  border-radius: 20px;
  padding: 3rem 2rem;
  margin-left: 256px;

  @media (max-width: 768px) {
    padding: 1.5rem !important;
    margin-left: 0 !important;
  }
`

/**
 * The styled container element that wraps the content of most pages and the tabs.
 */
export default function AppBody({ children, style }: { children: React.ReactNode; style?: React.CSSProperties }) {
  return <BodyWrapper style={style}>{children}</BodyWrapper>
}
